import { css as i } from "@microsoft/fast-element";
import { normalize as o } from "../common/normalize.js";
import { display as t } from "@matrix42/fast-foundation";
import { designTokens as e } from "../design-tokens.js";
const d = i`
  ${o}
  ${t("flex")}
  :host([hidden]) {
    display: none;
  }

  :host {
    display: block;
    overflow: hidden;
    width: 100%;
    position: relative;
    background-color: ${e.color.neutral[60]};
  }

  :host([shape='rect']) {
    border-radius: ${e.borderRadius.xs};
  }

  :host([shape='circle']) {
    border-radius: 100%;
    overflow: hidden;
  }

  object {
    height: auto;
    position: absolute;
    width: 100%;
    z-index: 2;
  }

  object img {
    height: auto;
    width: 100%;
  }

  .shimmer {
    position: absolute;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0,
      rgba(255, 255, 255, 0.1) 10%,
      rgba(255, 255, 255, 0.5) 40%,
      rgba(255, 255, 255, 0.5) 60%,
      rgba(255, 255, 255, 0.1) 90%,
      rgba(255, 255, 255, 0)
    );
    background-repeat: no-repeat;
    animation: shimmer 1.5s infinite;
    animation-timing-function: ease-in-out;
    animation-direction: normal;
    z-index: 1;
  }

  ::slotted(svg) {
    z-index: 2;
  }

  ::slotted(.pattern) {
    width: 100%;
    height: 100%;
  }

  @keyframes shimmer {
    0% {
      transform: translateX(-100%);
    }
    100% {
      transform: translateX(100%);
    }
  }
`;
export {
  d as skeletonStyles
};
